// extracted by mini-css-extract-plugin
var _1 = "Refer-module__content___vvMCY";
var _2 = "Refer-module__fields___FweIX";
var _3 = "Refer-module__heading___UmDNW";
var _4 = "Refer-module__invite___LxGLS";
var _5 = "Refer-module__link___Xyzij";
var _6 = "Refer-module__terms___wjlH0";
var _7 = "Refer-module__title___nmdf0";
var _8 = "Refer-module__yourInvites___HxriO";
export { _1 as "content", _2 as "fields", _3 as "heading", _4 as "invite", _5 as "link", _6 as "terms", _7 as "title", _8 as "yourInvites" }
